import LinkPairedWithText from '../text-pairing/Link';
/**
 * Icon does not have a non text-pairing glyph, so only use it in conjunction with a Button for example.
 */
const iconData = {
    // @ts-ignore exceptions which may get a non-text-pairing icon in the future
    glyph: undefined,
    group: 'basic',
    textPairingGlyph: LinkPairedWithText,
};
export default iconData;
